// Polyfills must be imported FIRST before any other code
// This provides Promise.withResolvers for older browsers (required by pdfjs-dist)
import "./polyfills";

// Sentry must be imported first to capture all errors
import "./sentry";

import * as Sentry from "@sentry/react";
import "@ant-design/v5-patch-for-react-19";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/mobile-tokens.css";

createRoot(document.getElementById("root")!, {
  // React 19 error hooks for Sentry integration
  // Captures errors NOT caught by any ErrorBoundary
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.error("Uncaught error:", error, errorInfo.componentStack);
  }),
  // Captures errors React automatically recovers from
  onRecoverableError: Sentry.reactErrorHandler(),
  // Note: onCaughtError is intentionally omitted since we use
  // <Sentry.ErrorBoundary> which already handles caught errors
}).render(<App />);
